/** The tabs of an installed app's page (`?tab=`), kept out of the lazily loaded page. */
export const INSTANCE_TABS = ["state", "revisions", "journal", "settings"] as const;
export type InstanceTab = (typeof INSTANCE_TABS)[number];
